import { cloneDeep } from 'lodash';
import { AnyAction } from 'redux';
import { DEFAULT_DATE_FILTER } from '../../shared/constants/commonConstants';
import { ALL } from '../../shared/constants/crmConstants';
import { defaultEndDate, defaultEndDateTime, defaultStartDate, defaultStartTime } from '../../utils/utility';
import actionTypes from '../types/inPatientTypes';

const defaultInitialState = {
  selectedDetail: [],
  selectedAction: 'All',
  globalSearch: '',
  filterAction: ALL,
  selectedItem: '',
  filters: {},

  isSearchClicked: 0,
  sortingKey: null,
  pageIndex: 1,
  isNextStatus: false,
  nextStatusFilters: {},
  isCourierClicked: false,
  isGlobalFilter: false,
  tpaNextStatus: undefined, // [ ENHANCEMENT, SUBMITINFO, CASHLESSSUMBIT, PENDINGQUERY, AWAITINGDISCHARGE, APPROVALPENDING, DRAFTCLAIM ]
  timeFilter: undefined, // [ All, Tomorrow, Today, Last3Hours ]
  tpaSecondaryFilter: undefined, // [ NewAdmission, Enhancement, Discharge ]
  isCountClicked : false,
  badRequestCount : 0,
  updateCourierDetailClicked: false,
  bulkUploadSelectedClaims: {},
  isDraftBtnClicked: false,
  settlementValue: '',
  selectedTagClass: [],
  otherCourierOptionService: '',
  payerNotConfig: false,
  isAllClicked: true,
  selectedBtnType: '',
  centerIdList: [],
  isEasyDischargeCase: false,
  uploadedFiles: [],
  isPreAuthView: true,
  viewCounts: {
    preAuthViewClaimCount: 0,
    claimViewClaimCount: 0,
  },
  searchDataVisible: false,
  updateCourierDetailBtnClicked: false,
  updateCourierDetailBtnClickedFlag: false,
  isInitiateSettelmentBtnClicked: false,
  displayFilters: {},
  selectedPrimaryFilter: '',
  tpaDeskSecondaryFilter: [],
  isDownloadClaimsModalOpen: false,
  isUploadClaimReportModalOpen: false,
  showTpaStartDateAndTime: {
    date: defaultStartDate,
    time: defaultStartTime,
  },
  showTpaEndDateAndTime: {
    date: defaultEndDate,
    time: defaultEndDateTime,
  },
  isFilteredPopoverVisible: false,
  showSelectedTpaPrimaryFilter: '',
  showSelectedTpaSecondaryFilters: [],
  isDateChanged : false,
  isClaimDetailApiLoaded: false,
  selectedDateDropdown: DEFAULT_DATE_FILTER,
  tpaGlobalSearchClicked: false,
  tpaGlobalSearch: {
    'key': 'patientName',
    'value': '',
  },
  tpaGlobalSearchValue: '',
  elapsedTimeDropdown: [],
  elapsedTimeColorConfig: null,
  selectedElapsedTimeRemarks: [],
  followUpDetails: {},
  followUpDetailsPayload: {},
};

const initialState = cloneDeep(defaultInitialState);

const reducer = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.SELECTED_INPATIENT_DETAIL:
      return {
        ...state,
        selectedDetail: action.payload,
      };
    case actionTypes.SELECTED_BUTTON_TYPE:
      return {
        ...state,
        selectedBtnType: action.payload,
      };
    case actionTypes.SELECTED_GLOBAL_SEARCH:
      return {
        ...state,
        globalSearch: action.payload,
      };
    case actionTypes.SET_FILTER_ACTION:
      return {
        ...state,
        filterAction: action.payload,
      };
    case actionTypes.SET_SELECTED_ITEM:
      return {
        ...state,
        selectedItem: action.payload,
      };
    case actionTypes.CLEAN_SEARCH_DETAIL:
      return cloneDeep(defaultInitialState);
    case actionTypes.UPDATE_DROPDOWN_SEARCH_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };
    case actionTypes.SEARCH_INPATIENT_LIST:
      return {
        ...state,
        isSearchClicked: state.isSearchClicked + 1,
      };
    case actionTypes.SET_SORTING_PREFERENCE:
      return {
        ...state,
        sortingKey: action.payload,
      };
    case actionTypes.SET_PAGE_INDEX:
      return {
        ...state,
        pageIndex: action.payload,
      };
    case actionTypes.NEXT_STATUS_ACTION:
      return {
        ...state,
        isNextStatus: action.payload,
      };
    case actionTypes.NEXT_STATUS_FILTER_ACTION:
      return {
        ...state,
        nextStatusFilters: action.payload,
      };
    case actionTypes.SET_COURIER_UPDATED:
      return {
        ...state,
        isCourierClicked: action.payload,
      };
    case actionTypes.SET_TPA_NEXT_STATUS:
      return {
        ...state,
        tpaNextStatus: action.payload,
      };
    case actionTypes.SET_TIME_FILTER:
      return {
        ...state,
        timeFilter: action.payload,
      };
    case actionTypes.SET_BAD_REQUEST_COUNT:
      return {
        ...state,
        badRequestCount: action.payload,
      };
    case actionTypes.SET_GLOBAL_FILTER:
      return {
        ...state,
        isGlobalFilter: action.payload,
      };
    case actionTypes.SET_TPA_SECONDARY_FILTER:
      return {
        ...state,
        tpaSecondaryFilter: action.payload,
      };
    case actionTypes.COUNT_CLICKED_ACTION:
      return {
        ...state,
        isCountClicked: action.payload,
      };

    case actionTypes.SET_UPDATE_COURIER_DETAIL_CLICKED:
      return {
        ...state,
        updateCourierDetailClicked: action.payload,
      };
    case actionTypes.SET_BULK_UPLOAD_SELECTED_CLAIMS:
      return {
        ...state,
        bulkUploadSelectedClaims: {
          ...state.bulkUploadSelectedClaims,
          ...action.payload,
        },
      };
    case actionTypes.RESET_BULK_UPLOAD_SELECTED_CLAIMS:
      return {
        ...state,
        bulkUploadSelectedClaims: {},
      };
    case actionTypes.SET_IS_DRAFT_BTN_CLICKED:
      return {
        ...state,
        isDraftBtnClicked: action.payload,
      };

    case actionTypes.SET_SETTLEMENT_VALUE:
      return {
        ...state,
        settlementValue: action.payload,
      };

    case actionTypes.SET_SELECTED_TAG_CLASS:
      return {
        ...state,
        selectedTagClass: action.payload,
      };

    case actionTypes.SET_OTHER_COURIER_SERVICE:
      return {
        ...state,
        otherCourierOptionService: action.payload,
      };

    case actionTypes.SET_PAYER_NOT_CONFIG:
      return {
        ...state,
        payerNotConfig: action.payload,
      };

    case actionTypes.SET_IS_ALL_CLICKED:
      return{
        ...state,
        isAllClicked: action.payload,
      };
  case actionTypes.DELETE_KEY_FROM_BULK_UPLOAD_SELECTED_CLAIMS:
    const newBulkUpdateClaimsObject = { ...state.bulkUploadSelectedClaims };
      delete newBulkUpdateClaimsObject[action.payload];
      return {
        ...state,
        bulkUploadSelectedClaims: {
        ...newBulkUpdateClaimsObject,
        },
      };
  case actionTypes.SET_CENTER_ID_LIST:
    return {
      ...state,
      centerIdList: action.payload,
    };
    case actionTypes.SET_IS_EASY_DISCHARGE_CASE:
      return{
        ...state,
        isEasyDischargeCase: action.payload,
    };
    case actionTypes.SET_UPLOADED_FILES:
      return {
        ...state,
        uploadedFiles: action.payload,
      };
    case actionTypes.SET_IS_PRE_AUTH_VIEW:
      return {
        ...state,
        isPreAuthView: action.payload,
      };
    case actionTypes.SET_VIEW_COUNTS:
      return {
        ...state,
        viewCounts: action.payload,
      };
    case actionTypes.SET_SEARCH_DATA_VISIBILE:
      return {
        ...state,
        searchDataVisible: action.payload,
      };
    case actionTypes.SET_UPDATE_COURIER_DETAIL_BTN_CLICKED:
      return {
        ...state,
        updateCourierDetailBtnClicked: action.payload,
      };
    case actionTypes.SET_UPDATE_COURIER_DETAIL_BTN_CLICKED_FLAG:
      return {
        ...state,
        updateCourierDetailBtnClickedFlag: action.payload,
      };
    case actionTypes.SET_INITIATE_SETTELMENT_BTN_CLICKED:
      return {
        ...state,
        isInitiateSettelmentBtnClicked: action.payload,
      };
    case actionTypes.UPDATE_DISPLAY_DROPDOWN_SEARCH_FILTER:
      return {
        ...state,
        displayFilters: {
          ...state.filters,
          ...action.payload,
        },
      };
    case actionTypes.SELECTED_PRIMARY_FILTER:
      return {
        ...state,
        selectedPrimaryFilter: action.payload,
      };
    case actionTypes.TPA_DESK_SECONDARY_FILTER:
      return {
        ...state,
        tpaDeskSecondaryFilter: action.payload,
      };
    case actionTypes.IS_DOWNLOAD_CLAIMS_MODAL_OPEN:
      return {
        ...state,
        isDownloadClaimsModalOpen: action.payload,
      };
    case actionTypes.IS_UPLOAD_CLAIM_REPORT_MODAL_OPEN:
      return {
        ...state,
        isUploadClaimReportModalOpen: action.payload,
      };
    case actionTypes.SHOW_TPA_START_DATE_AND_TIME:
      return {
        ...state,
        showTpaStartDateAndTime: action.payload,
      };
    case actionTypes.SHOW_TPA_END_DATE_AND_TIME:
      return {
        ...state,
        showTpaEndDateAndTime: action.payload,
      };
    case actionTypes.IS_FILTERED_POPOVER_VISIBLE:
      return {
        ...state,
        isFilteredPopoverVisible: action.payload,
      };
    case actionTypes.SHOW_SELECTED_TPA_PRIMARY_FILTER:
      return {
        ...state,
        showSelectedTpaPrimaryFilter: action.payload,
      };
    case actionTypes.SHOW_SELECTED_TPA_SECONDARY_FILTERS:
      return {
        ...state,
        showSelectedTpaSecondaryFilters: action.payload,
      };
    case actionTypes.SET_IS_DATE_CHANGED:
      return {
        ...state,
        isDateChanged: action.payload,
      };
    case actionTypes.IS_CLAIM_DETAIL_API_LOADED:
       return {
         ...state,
         isClaimDetailApiLoaded: action.payload,
          };
    case actionTypes.SET_SELECTED_DATE_DROPDOWN:
      return {
        ...state,
        selectedDateDropdown: action.payload,
      };
    case actionTypes.SET_TPA_GLOBAL_SEARCH:
      return {
        ...state,
        tpaGlobalSearch: action.payload,
      };
    case actionTypes.SET_TPA_GLOBAL_SEARCH_CLICKED:
     return {
        ...state,
        tpaGlobalSearchClicked: action.payload,
      };
    case actionTypes.SET_TPA_GLOBAL_SEARCH_VALUE:
      return {
        ...state,
        tpaGlobalSearchValue: action.payload,
      };
    case actionTypes.RESET_INPATIENT_FILTERS:
      return {
      ...state,
        filters: {},
      };
    case actionTypes.SET_ELAPSED_TIME_DROPDOWN:
      return {
        ...state,
        elapsedTimeDropdown: action.payload,
      };
    case actionTypes.SET_ELAPSED_TIME_COLOR_CONFIG:
      return {
        ...state,
        elapsedTimeColorConfig: action.payload,
      };
    case actionTypes.SELECTED_ELAPSED_TIME_REMARKS:
      return {
        ...state,
        selectedElapsedTimeRemarks: action.payload,
      };
    case actionTypes.FOLLOWUP_DETAILS:
      return {
        ...state,
        followUpDetails: action.payload,
      };
    case actionTypes.FOLLOW_UP_DETAILS_PAYLOAD:
      return {
        ...state,
        followUpDetailsPayload: action.payload,
      };
    default:
      return state;
  }
};

export { reducer as inPatientReducer };
